import type { ReactNode } from 'react'
import { ViewOnlyBadge } from './app-shell'

/** Grouped reports keep their picker, summary panel and table on the page canvas. */
export function ReportPage({
  title,
  controls,
  children,
}: {
  title: string
  controls: ReactNode
  children: ReactNode
}) {
  return (
    <div className="mx-auto w-full max-w-[1200px] px-6 py-6">
      <header>
        <div className="flex items-center gap-3">
          <h1 className="text-heading-sm font-semibold">{title}</h1>
          <ViewOnlyBadge />
        </div>
        <div className="mt-3 flex flex-wrap items-center gap-2">{controls}</div>
      </header>
      {children}
    </div>
  )
}
